// extracted by mini-css-extract-plugin
export var editButton = "_o9-0";